// fallow-ignore-file complexity
// fallow-ignore-file coverage-gaps
import { useOnboardingStatus } from "@/api/hooks";
import { storedBusinessId } from "@/lib/onboarding-storage";

export function useBusinessId(): string | null {
  const stored = storedBusinessId();
  const { data: status } = useOnboardingStatus(stored);
  return (
    status?.businesses.find((business) => business.id === stored)?.id ??
    status?.selected_business_id ??
    null
  );
}

export { clearBusinessId, persistBusinessId } from "@/lib/onboarding-storage";
